<!--<div class="container d-flex w-100 align-items-center">-->
<!--  <div class="row w-100">-->
<!--    <div class="col-lg-6"></div>-->
<!--    <div class="col-lg-6" style="">-->
<!--      <div class="card mb-1">-->
<!--        <div class="card-body py-1">-->
<!--          <div class="my-1 pb-1">-->
<!--            <input type="text" class="input" [(ngModel)]="email" placeholder="email@binst.com" />-->
<!--          </div>-->
<!--          <div class="my-1 pb-1">-->
<!--            <input type="password" class="input" [(ngModel)]="password" placeholder="password" />-->
<!--          </div>-->
<!--          <div class="w-100 d-flex flex-wrap justify-content-between">-->
<!--            <button class="button">Register</button>-->
<!--            <button (click)="enter()" class="btn-enter my-4">Enter</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="mt-3 d-flex w-100 justify-content-center">-->
<!--        <div class="unknown">-->
<!--          {{ error | async }}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<div class="container">
    <div class="d-flex row justify-content-end">
        <div class="col-md-6">
            <div class="outer">
                <div class="pane">
                    <div class="my-3">
                        <input type="email" class="input input-round" [(ngModel)]="email" placeholder="email@binst.com"/>
                    </div>
                    <div class="my-3">
                        <input type="password" class="input input-round" [(ngModel)]="password" placeholder="password"/>
                    </div>
                    <div class="d-flex w-100 justify-content-between mt-3">
                        <a class="btn button pointer" href="/auth/signup">Register</a>
                        <a class="btn button pointer" (click)="enter()">Enter</a>
                    </div>
                    <div class="w-200 d-flex justify-content-center">
                        <a href="{{apiUrl}}/auth/google/login">Login with google</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 mt-5 pt-5">
            <h2>What is Binst?</h2>
            <p>Binst is a public social media platform designed as an infinite open, digital billboard. Anyone can sign up and share text and images instantly — no followers, no privacy settings, no algorithms. Everything posted on Binst is visible to the entire world.</p>
            <h2>How it works</h2>
            <p>Create an account using your Google login, then start posting. Your content appears publicly on the platform for all visitors to see, whether they have an account or not. You can update your display name, email, and profile picture at any time.</p>
            <h2>Your data & why we request it</h2>
            <p>Binst uses Google OAuth to authenticate users. When you sign in with Google, we request access to your <strong>name</strong>, <strong>email address</strong>, and <strong>profile picture</strong> solely to create and identify your account on the platform. We do not use this information for advertising, and we do not sell your data.</p>
            <a href="/privacy">Read our Privacy Policy</a><br>
            <a href="/terms-of-service">Terms of servicce</a>
        </div>
    </div>
</div>
